module.exports = __webpack_public_path__ + "img/rob-yourcarsold-car-buyers-dealers-rockingham-perth-wa.7c229e93.jpg";